export const START_CONTENT_LOADER = 'START_CONTENT_LOADER';
export const STOP_CONTENT_LOADER = 'STOP_CONTENT_LOADER';
export const START_TOPBAR_LOADER = 'START_TOPBAR_LOADER';
export const STOP_TOPBAR_LOADER = 'STOP_TOPBAR_LOADER';